import React, { useState, useEffect } from "react";
import { useCart } from "@/contexts/CartContext";
import { getReferralForEvent } from "@/utils/referralLinkManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useKlapScript } from "@/hooks/useKlapScript";
// import { trackEvent } from "@/analytics";

export default function CartSummary({
  tickets,
  carritoUid,
  onCloseCart,
  onOpenPayment,
  eventoUid,
  showError,
  isUpdatingCart,
}) {
  const [payOrderId, setPayOrderId] = useState("");
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [totalCart, setTotalCart] = useState(0);

  const { isReady: isKlapReady } = useKlapScript();

  // Context para iniciar pago con KLAP
  const { initiateKlapPayment } = useCart();

  // Calcular y actualizar el total cuando cambien los tickets
  useEffect(() => {
    const subTotal = tickets.reduce((acc, t) => acc + t.precio * t.cantidad, 0);
    const discount = 0;
    const calculatedTotal = +(subTotal - discount);
    setTotalCart(calculatedTotal);
  }, [tickets]);

  // Función payOrder solo se ejecuta si payOrderId tiene valor
  // const payOrder = (orderId) => {
  //   if (!orderId || orderId === "" || orderId === null || orderId === undefined) {
  //     console.warn("[CartSummary] payOrder llamado sin orderId válido");
  //     payKlapOrder(orderId);
  //     return;
  //   }

  //   console.log("[CartSummary] Procesando pago con orderId:", orderId);
  //   // Aquí puedes agregar lógica adicional si es necesaria
  //   // Por ahora, el flujo principal se maneja en handleInitiatePayment
  // };

  // Función para iniciar el proceso de pago con KLAP
  const handleInitiatePayment = async () => {
    if (isLoadingPayment || isUpdatingCart || !isKlapReady) return;

    // trackEvent("click_gestionar_pago", { category: "Carrito", label: carritoUid });

    setIsLoadingPayment(true);

    try {
      // Obtener código de referido si existe
      console.log(
        "[CartSummary] Iniciando proceso de pago para carritoUid:",
        carritoUid,
        "y eventoUid:",
        eventoUid
      );
      const referralInfo = getReferralForEvent(eventoUid);
      console.log("[CartSummary] referralInfo obtenido:", referralInfo);
      const ambassadorReferralCode = referralInfo?.code || null;
      console.log(
        "[CartSummary] Usando ambassadorReferralCode:",
        ambassadorReferralCode
      );

      // Llamar al backend para obtener el klapOrderId
      const result = await initiateKlapPayment(
        carritoUid,
        ambassadorReferralCode
      );

      if (result.success && result.data?.klapOrderId) {
        let orderId = "";
        orderId = result.data.klapOrderId;
        console.log("[CartSummary] klapOrderId obtenido:", orderId);

        // Guardar el orderId en el estado
        setPayOrderId(orderId);

        // Cerrar el modal del carrito
        onCloseCart();

        // console.log("[CartSummary] Iniciando pago con KLAP para orderId:", orderId);
        // Iniciar el pago con KLAP
        payKlapOrder(orderId);

        // Llamar a payOrder con el orderId obtenido
        // payOrder(orderId);

        // Abrir el modal de pago con el orderId
        onOpenPayment(carritoUid, orderId);
      } else {
        // Error en la respuesta
        const errorMessage =
          result.error?.message ||
          result.error ||
          "No se pudo obtener el ID de la orden de pago";
        const errorCode = result.error?.code;
        console.error(
          "[CartSummary] Error:",
          errorMessage,
          "Code:",
          errorCode,
          errorCode === "SELF_REFERRAL"
        );

        // Mostrar mensaje específico para errores de referido
        if (errorCode === "SELF_REFERRAL" || errorCode === "INVALID_REFERRAL") {
          const storedReferrals = localStorage.getItem("ambassador_referrals");

          if (storedReferrals) {
            // Parsear el objeto de referidos
            const referralsObj = JSON.parse(storedReferrals);

            console.log("[CartSummary] Limpiando referido inválido para evento:", eventoUid);
            // Obtener el referido para este evento
            const referralForEvent = getReferralForEvent(eventoUid);

            // Si existe, eliminarlo del objeto y guardar de nuevo
            if (referralForEvent) {
              // Eliminar el referido de este evento
              delete referralsObj[eventoUid];
              // Guardar el objeto actualizado en localStorage
              localStorage.setItem(
                "ambassador_referrals",
                JSON.stringify(referralsObj)
              );
              console.log("[CartSummary] Referido eliminado del localStorage");
            }
          }

          // Mostrar mensaje según el tipo de error
          if (errorCode === "SELF_REFERRAL") {
            showError?.(
              "Código removido: no puedes usar tu propio código. Continua comprando sin código o usa otro."
            );
          } else if (errorCode === "INVALID_REFERRAL") {
            showError?.(
              "Código removido: es inválido o está desactivado. Continua comprando sin código o usa otro."
            );
          }
        } else {
          showError?.(errorMessage);
        }
      }
    } catch (err) {
      console.error("[CartSummary] Error al iniciar pago:", err);
      showError?.(
        "Error al iniciar el proceso de pago. Por favor intenta nuevamente."
      );
    } finally {
      setIsLoadingPayment(false);
    }
  };

  return (
    <div className="mt-4 text-white text-sm">
      {/* <div className="flex justify-between py-1">
        <span>Sub Total</span>
        <span>${subTotal.toLocaleString()}</span>
      </div> */}
      {/* <div className="flex justify-between py-1">
        <span>Cargo por servicio</span>
        <span>${serviceFee.toLocaleString()}</span>
      </div> */}
      {/* <div className="flex justify-between py-1 font-bold text-aw-green">
        <span>Descuento del 20% por cargo</span>
        <span>${-discount.toLocaleString()}</span>
      </div> */}
      <div className="flex justify-between py-1 text-lg font-bold">
        <span>Total a pagar</span>
        {/* <span>${totalCart.toLocaleString()}</span> */}

        {isUpdatingCart || totalCart === 0 ? (
          <FontAwesomeIcon
            icon="fa-solid fa-spinner"
            spin
            className="text-aw-green"
          />
        ) : (
          <span>${totalCart.toLocaleString()}</span>
        )}
      </div>
      <button
        onClick={handleInitiatePayment}
        disabled={isLoadingPayment || isUpdatingCart || !isKlapReady}
        className={`w-full mt-5 bg-aw-green text-black font-bold py-2 rounded-lg text-lg transition-colors ${
          isLoadingPayment || isUpdatingCart || !isKlapReady
            ? "opacity-50 cursor-not-allowed"
            : "hover:bg-aw-green/80"
        }`}
      >
        {isLoadingPayment
          ? "Procesando..."
          : isUpdatingCart
          ? "Actualizando carrito..."
          : !isKlapReady
          ? "Cargando pasarela..."
          : "Gestionar Pago"}
      </button>
    </div>
  );
}
